import React from 'react';
import { reportError } from '@/lib/errorReporter';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMsg: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, errorMsg: error?.message || 'Unknown error' };
  }
  componentDidCatch(error, info) {
    reportError({
      source: 'frontend',
      level: 'error',
      message: error?.message || 'React ErrorBoundary',
      stack: (error?.stack || '') + '\n--- componentStack ---\n' + (info?.componentStack || ''),
      context: { type: 'react_error_boundary' },
    });
  }
  reset = () => this.setState({ hasError: false, errorMsg: null });

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 32, minHeight: '100vh', background: '#0b0b0e', color: '#e6e6e6', fontFamily: 'system-ui, sans-serif' }}>
          <h1 style={{ fontSize: 24, marginBottom: 12 }}>Coś się wysypało</h1>
          <p style={{ opacity: 0.75, marginBottom: 16 }}>Błąd został automatycznie zaraportowany. Możesz spróbować dalej lub odświeżyć stronę.</p>
          <pre style={{ background: '#1a1a22', padding: 12, borderRadius: 6, maxWidth: '100%', overflowX: 'auto', fontSize: 12 }}>
            {this.state.errorMsg}
          </pre>
          <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
            <button onClick={this.reset} style={btnStyle}>Spróbuj ponownie</button>
            <button onClick={() => window.location.reload()} style={btnStyle}>Odśwież</button>
            <button onClick={() => (window.location.href = '/')} style={btnStyle}>Strona główna</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const btnStyle = {
  padding: '8px 16px',
  background: '#2a2a35',
  color: '#e6e6e6',
  border: '1px solid #3a3a45',
  borderRadius: 6,
  cursor: 'pointer',
};

export default ErrorBoundary;
